import React, { useState, useEffect } from "react";
import { useIntl } from 'react-intl';

import { useDebounce } from 'use-debounce';

function SearchBar({ filterState, handleSearchChange }) {
    const intl = useIntl();
    const [inputValue, setInputValue] = useState(filterState.searchText);
    const [debouncedInputValue] = useDebounce(inputValue, 100);

    useEffect(() => {
        handleSearchChange(debouncedInputValue);
    }, [debouncedInputValue, handleSearchChange]);

    useEffect(() => {
        if (!filterState.searchText && inputValue) {
            setInputValue('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterState.searchText]);

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    return (
        <input
            type="search"
            placeholder={intl.formatMessage({ id: 'main.search', defaultMessage: 'Search' })}
            className="search-bar"
            onChange={handleInputChange}
            value={inputValue}
        />
    );
}

export default SearchBar;